import React from "react";

const Section5 = ({ data }) => {
  return (
    <div className="2xl:container md:px-10 lg:px-20  px-6 w-full flex flex-col justify-center mt-[36px] lg:mt-[90px]">
      <div className="w-full flex justify-center">
      <h2 className="font-semibold text-24 md:text-36 lg:text-48 text-primarycolor px-6 text-center w-full md:px-10 lg:px-20   w-full lg:w-[85%]">
        {data.title}
      </h2>   
      </div>
         <div className="w-full flex flex-col-reverse lg:flex-row justify-between items-center gap-[80px] md:gap-[120px] md:py-20 py-10 ">
        <div className=" sm:w-[85%] lg:w-[50%] flex flex-col gap-6">
          {data.desc1.map((it, i) => (
            <div className="flex flex-col p-6 gap-4 border-[1px] border-journyborder rounded-[16px] shadow-services">
              <div className="flex gap-6 items-start">
                <img src={process.env.PUBLIC_URL + "/images/content/section2/Content Transformation/check icon.svg"} alt="icon" />
                <h4 className="text-18 font-medium sm:text-20 md:text-24 text-primarycolor">{it.heading}</h4>
              </div>
              <p className="text-14 sm:text-16 text-secondaryblack font-regular">{it.desc}</p>

            </div>
          ))}
        </div>
        <div className=" w-[90%] sm:w-[60%] lg:w-[40%] h-fit">
          <img className="w-full" src={process.env.PUBLIC_URL + "/images/content/section2/Content Transformation/right-side.webp"} alt="img" />
        </div>
       
      </div>
    </div>
  );
};

export default Section5;
